var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTierLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "url(#paint0_linear_23909_2312)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.954504,
    y: 0.950597,
    width: 10.0983,
    height: 10.0983,
    rx: 5.04914,
    stroke: "url(#paint1_linear_23909_2312)",
    strokeWidth: 0.705882
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50781 5.22716L4.6434 5.6114C4.6434 5.6114 6.16133 4.66591 6.70383 4.33064C7.41956 3.70909 6.798 2.71855 6.12006 2.72596C5.95601 2.72122 5.79386 2.76199 5.65157 2.84377C5.50928 2.92555 5.39242 3.04513 5.31393 3.18926C5.05409 3.60736 5.29504 4.20654 5.5248 4.3228C5.55489 4.30391 5.78842 4.13387 5.85629 4.08926C5.50969 3.87839 5.43485 3.18519 6.08983 3.11746C6.60588 3.09857 6.75659 3.788 6.46651 4.02895C6.37234 4.08592 4.50781 5.22716 4.50781 5.22716Z",
    fill: "url(#paint2_linear_23909_2312)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30469 4.81011L6.67004 4.59546C6.67004 4.59546 8.14655 5.69529 8.35756 5.80835C8.43009 5.85436 8.51327 5.88088 8.59904 5.88533C8.68482 5.88978 8.7703 5.87201 8.8472 5.83375C8.9241 5.79549 8.98982 5.73803 9.03801 5.66693C9.0862 5.59583 9.11522 5.51349 9.12227 5.42789C9.15235 4.71972 8.18811 4.73861 8.09772 5.2923C7.95079 5.19057 7.92071 5.15671 7.77379 5.05498C7.96969 4.45609 8.70038 4.37326 9.07707 4.57279C9.22943 4.65287 9.3543 4.77679 9.43553 4.92854C9.51677 5.08029 9.55066 5.25291 9.53281 5.42411C9.44998 6.20001 8.68149 6.50141 8.19189 6.17748C7.93946 6.00411 6.30469 4.81011 6.30469 4.81011Z",
    fill: "url(#paint3_linear_23909_2312)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4179 5.9082L7.74183 6.1493C7.74183 6.1493 7.03743 8.09667 7.01113 8.18386C6.99132 8.26089 6.98939 8.34142 7.00548 8.41931C7.02156 8.4972 7.05524 8.57038 7.10394 8.63325C7.15264 8.69613 7.21507 8.74704 7.28646 8.7821C7.35785 8.81715 7.43631 8.83542 7.51584 8.8355C8.21268 8.79408 8.21646 7.80718 7.47065 7.79206C7.54593 7.56986 7.56482 7.53585 7.6138 7.4116C7.85324 7.44508 8.07097 7.56844 8.22277 7.75662C8.37457 7.9448 8.44905 8.1837 8.43111 8.42481C8.39182 8.63532 8.28412 8.82697 8.12475 8.97001C7.96537 9.11304 7.76323 9.19945 7.54971 9.21582C6.80767 9.23035 6.54405 8.5341 6.63415 8.10844C6.70972 7.89699 7.4179 5.9082 7.4179 5.9082Z",
    fill: "url(#paint4_linear_23909_2312)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47881 7.88629L6.62574 7.46484C6.62574 7.46484 4.55789 7.46862 4.25692 7.46862C3.50356 7.50248 3.29647 8.21065 3.41316 8.63254C3.86513 9.86781 5.46226 9.15571 5.15344 8.13538C5.02163 8.1316 4.80684 8.12782 4.74653 8.12782C4.867 8.47442 4.69 8.8623 4.28701 8.87363C4.16135 8.87374 4.04025 8.82659 3.94774 8.74154C3.85524 8.65649 3.7981 8.53977 3.78767 8.41454C3.77724 8.28932 3.81428 8.16475 3.89144 8.06557C3.96859 7.96639 4.08023 7.89985 4.20417 7.87917C4.33947 7.88295 6.47881 7.88629 6.47881 7.88629Z",
    fill: "url(#paint5_linear_23909_2312)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49834 7.28498H4.93155C4.93155 7.28498 4.27613 5.22455 4.24227 5.10785C4.20386 4.98427 4.13923 4.87044 4.05279 4.77414C3.96635 4.67783 3.86014 4.60132 3.74141 4.54982C3.62269 4.49833 3.49425 4.47308 3.36487 4.47578C3.23549 4.47849 3.10821 4.50909 2.99174 4.5655C2.64892 4.78014 2.42672 5.08155 2.50955 5.54863C2.60372 6.06846 3.11992 6.55806 3.84655 6.16641C3.79002 5.96295 3.76749 5.87575 3.73349 5.75208C3.66036 5.82311 3.56758 5.87053 3.46717 5.88818C3.36677 5.90584 3.26338 5.89291 3.17041 5.85109C3.07744 5.80927 2.99918 5.74047 2.94579 5.65363C2.8924 5.56678 2.86633 5.4659 2.87098 5.36406C2.88363 5.25393 2.93146 5.15081 3.00738 5.07003C3.0833 4.98925 3.18325 4.93511 3.29238 4.91566C3.40152 4.89621 3.51402 4.91247 3.61317 4.96205C3.71233 5.01162 3.79285 5.09185 3.84277 5.19083C3.88448 5.31494 4.49834 7.28498 4.49834 7.28498Z",
    fill: "url(#paint6_linear_23909_2312)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23909_2312",
    x1: 6,
    y1: 0,
    x2: 6,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#1D1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760417,
    stopColor: "#1F1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23909_2312",
    x1: 6.00365,
    y1: 0.597656,
    x2: 6.00365,
    y2: 11.4018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCAC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A6834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23909_2312",
    x1: 5.76498,
    y1: 2.72559,
    x2: 5.76498,
    y2: 5.6114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D773A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "#FCE29C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "#B79539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807292,
    stopColor: "#9C8C61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFD384"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_23909_2312",
    x1: 7.92107,
    y1: 4.47559,
    x2: 7.92107,
    y2: 6.30608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D773A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "#FCE29C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "#B79539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807292,
    stopColor: "#9C8C61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFD384"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_23909_2312",
    x1: 7.52546,
    y1: 5.9082,
    x2: 7.52546,
    y2: 9.21604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D773A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "#FCE29C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "#B79539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807292,
    stopColor: "#9C8C61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFD384"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_23909_2312",
    x1: 5.00428,
    y1: 7.46484,
    x2: 5.00428,
    y2: 9.28712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D773A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "#FCE29C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "#B79539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807292,
    stopColor: "#9C8C61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFD384"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_23909_2312",
    x1: 3.71187,
    y1: 4.47559,
    x2: 3.71187,
    y2: 7.28498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D773A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "#FCE29C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "#B79539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807292,
    stopColor: "#9C8C61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFD384"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierLogo);
export default __webpack_public_path__ + "static/media/tierLogo.5bf63a5b1e7efc9754c93fab0277a331.svg";
export { ForwardRef as ReactComponent };